<template>
  <div class="min-h-screen bg-white">
    <Head :title="specialisation.name" />

    <!-- Back Link -->
    <div class="bg-white shadow">
      <div class="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
        <Link
          :href="$routes.specialisations_index({ site_context: specialisation.site_context })"
          class="inline-flex items-center text-sm text-gray-500 hover:text-gray-700"
        >
          <svg class="mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
          Back to Specialisations
        </Link>
      </div>
    </div>

    <!-- Specialisation Detail -->
    <div class="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
      <div class="overflow-hidden bg-white shadow-lg sm:rounded-lg">
        <div class="p-6 md:p-8">
          <div class="mb-2 text-sm font-medium text-indigo-600">
            {{ site_context_label }}
          </div>
          <h1 class="text-4xl font-bold text-gray-900">
            {{ specialisation.name }}
          </h1>

          <!-- Description -->
          <div v-if="specialisation.description" class="mt-6">
            <h2 class="text-lg font-semibold text-gray-900">About</h2>
            <p class="mt-2 whitespace-pre-line text-gray-600">
              {{ specialisation.description }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3';
import Layout from '@/Layouts/Main.vue';

export default {
  components: {
    Head,
    Link,
  },
  layout: Layout,
  props: {
    specialisation: {
      type: Object,
      required: true,
    },
    // eslint-disable-next-line vue/prop-name-casing
    site_context_label: {
      type: String,
      default: '',
    },
  },
};
</script>
